import React, { Fragment, FunctionComponent } from "react";
import styles from "./DynamicHeading.module.scss";
import DynamicHeadingProps from "./DynamicHeadingProps.interface";

import combineClasses from "helpers/combine-classes";

const DynamicHeading: FunctionComponent<DynamicHeadingProps> = (props) => {
    const headlineSizeClass = props.headlineSize ? styles[props.headlineSize] : styles["H2"];

    let HeadingWeight = "h2" as keyof JSX.IntrinsicElements;
    if (props.headlineWeight) {
        HeadingWeight = props.headlineWeight.toLowerCase() as keyof JSX.IntrinsicElements;
    }

    return (
        <Fragment>
            <HeadingWeight className={combineClasses([props.className, headlineSizeClass])} dangerouslySetInnerHTML={props.innerHTML}>
                {props.children}
            </HeadingWeight>
        </Fragment>
    );
};

export default DynamicHeading;